import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlideTallAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSlideTallAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2V22H20V2H4ZM8 11V13H11V16H13V13H16V11H13V8H11V11H8Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlideTallAdd;
